import { useEffect } from "preact/hooks";
import { refreshMe, requireMe } from "../../state/auth";
import { requireMeta, requireMetaIndex } from "../../state/meta";
import { ScreenFrame } from "../components/ScreenFrame";
import { IdentityPanel } from "./profile/IdentityPanel";
import { Roadmap } from "./profile/Roadmap";
import { StatsGrid } from "./profile/StatsGrid";
import { WeaponLevels } from "./profile/WeaponLevels";

/** Career screen: identity and lifetime stats on the left, weapon levels and unlock roadmap on the right. */
export function Profile() {
  const account = requireMe();
  const catalog = requireMeta();
  const index = requireMetaIndex();
  // Results of a match that ended after the player left (a ranked leaver's loss, a forfeit) land
  // after the refresh on leaving, so fetch the account again whenever the screen opens.
  useEffect(() => {
    void refreshMe().catch(() => undefined);
  }, []);

  return (
    <ScreenFrame title="Profile" kicker="Career" bodyClass="profile__body">
      <div class="profile__col">
        <IdentityPanel user={account.user} profile={account.profile} progression={catalog.progression} />
        <StatsGrid profile={account.profile} />
      </div>
      <div class="profile__col profile__col--right">
        <WeaponLevels
          weaponProgress={account.weaponProgress}
          unlockedWeapons={account.unlocks.weapons}
          progression={catalog.progression}
          index={index}
        />
        <Roadmap playerLevel={account.profile.level} progression={catalog.progression} index={index} />
      </div>
    </ScreenFrame>
  );
}
